var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedinScraper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#2783EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9432 14.5752H18.9144V16.0552C19.3424 15.204 20.44 14.4392 22.0888 14.4392C25.2496 14.4392 26 16.1336 26 19.2424V25H22.8V19.9504C22.8 18.18 22.372 17.1816 21.2824 17.1816C19.7712 17.1816 19.1432 18.2576 19.1432 19.9496V25H15.9432V14.5752ZM10.456 24.864H13.656V14.4392H10.456V24.864ZM14.1144 11.04C14.1145 11.3082 14.0613 11.5738 13.9579 11.8213C13.8545 12.0688 13.7029 12.2932 13.512 12.4816C13.3205 12.6721 13.0934 12.823 12.8435 12.9257C12.5937 13.0283 12.3261 13.0808 12.056 13.08C11.5117 13.0788 10.9895 12.8642 10.6016 12.4824C10.4114 12.2933 10.2604 12.0686 10.1572 11.8211C10.054 11.5736 10.0006 11.3082 10 11.04C10 10.4984 10.216 9.98 10.6024 9.5976C10.9894 9.21431 11.5121 8.9995 12.0568 9C12.6024 9 13.1256 9.2152 13.512 9.5976C13.8984 9.98 14.1144 10.4984 14.1144 11.04Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedinScraper);
export default __webpack_public_path__ + "static/media/icon-linkedin-scraper.4f310bb95d72d2aa1e735a35a89afdcd.svg";
export { ForwardRef as ReactComponent };